import React from 'react';
import PropTypes from 'prop-types';
import { Helmet } from 'react-helmet';
import { useStaticQuery, graphql } from 'gatsby';
import "@fontsource/roboto/900.css" // Weight 500.
import "@fontsource/roboto/700.css" // Weight 500.
import "@fontsource/roboto/500.css" // Weight 500.
import "@fontsource/roboto/400.css" // Weight 500.
import "@fontsource/roboto/300.css" // Weight 500.
import "@fontsource/roboto/100.css" // Weight 500.

function SEO({ description, lang, meta, title }) {
  const { site } = useStaticQuery(
    graphql`
      query {
        site {
          siteMetadata {
            title
            description
          }
        }
      }
    `
  );

  const metaDescription = description || site.siteMetadata.description;

  return (
    <Helmet
      htmlAttributes={{
        lang,
      }}
      title={title}
      titleTemplate={`%s | ${site.siteMetadata.title}`}
      meta={[
        {
          name: `description`,
          content: metaDescription,
        },
        {
          itemprop: `image`,
          content: `https://s3-us-west-1.amazonaws.com/arise.travel/assets/site-preview.png`,
        },
        {
          property: `og:title`,
          content: title,
        },
        {
          property: `og:url`,
          content: `https://arise.travel/`,
        },
        {
          property: `og:image`,
          content: `https://s3-us-west-1.amazonaws.com/arise.travel/assets/site-preview.png`,
        },
        {
          property: `og:description`,
          content: metaDescription,
        },
        {
          property: `og:type`,
          content: `website`,
        },
        {
          name: `twitter:title`,
          content: title,
        },
        {
          name: `twitter:creator`,
          content: `@arisetechnology`,
        },
        {
          name: `twitter:image:src`,
          content: `https://s3-us-west-1.amazonaws.com/arise.travel/assets/site-preview.png`,
        },
        {
          name: `twitter:description`,
          content: metaDescription,
        },
      ].concat(meta)}
    />
  );
}

SEO.defaultProps = {
  lang: `en`,
  meta: [],
  description: ``,
};

SEO.propTypes = {
  description: PropTypes.string,
  lang: PropTypes.string,
  meta: PropTypes.arrayOf(PropTypes.object),
  title: PropTypes.string.isRequired,
};

export default SEO;
